import React, { useEffect, useState } from "react";
import styled from "styled-components";
import UniversalLogout from "../userAuth/UniversalLogout";
import AccountDeletion from "../userAuth/AccountDeletion";
import DisplayNameModal from "./DisplayNameModal";
import { Link, useHistory } from "react-router-dom";
import { useAmazonContext } from "../../Contexts/AmazonContext";
import BottomNavBar from "./BottomNavBar";
import { FaUser, FaEnvelope, FaCrown, FaSmile, FaTrash, FaPen } from "react-icons/fa";
import SolidButton from "../SolidButton";
import api from "../api";

import {
  Header,
  ScrollContainer,
  BookCover,
  CoverImage,
  NavButton,
} from "./landingPageSharedStyledComponents";

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ProfileInfo = styled.div`
  background-color: #d2cfe6;
  padding: 20px;
  border-radius: 10px;
  margin: 0;
`;

const InfoItem = styled.div`
  font-size: 2.5vh;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.isDarkMode ? "var(--font-dark)" : "var(--font-light)"};
  font-family: "Quicksand", sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  svg {
    margin-right: 10px;
    color: #8747d4;
  }
`;

const NameCard = styled.div`
  background: ${(props) => (props.isDarkMode ? "rgba(45,45,45,0.75)" : "#ffffff")};
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 12px;
  border: 1px solid ${(props) => (props.isDarkMode ? "#4a4a4a" : "#e5d9f5")};
`;

const NameRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: ${(props) => (props.noMargin ? "0" : "10px")};
`;

const NameText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const NameLabel = styled.span`
  font-family: "Quicksand", sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: ${(props) => (props.isDarkMode ? "#f7c054" : "#6535a0")};
`;

const NameValue = styled.span`
  font-family: "Quicksand", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) =>
    props.isDarkMode ? "var(--font-dark)" : "var(--font-light)"};
  white-space: normal;
  word-break: break-word;
`;

const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 150px);
  gap: 10px;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;

  button,
  a {
    font-size: 14px;
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin-top: 20px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #eb8381;
    transition: 0.4s;
    border-radius: 34px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #b0240f;
  }

  input:checked + .slider:before {
    transform: translateX(26px);
    background-color: white;
  }
`;

const ThemeToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding: 0 20px;
  width: 100%;
  margin: 0;
  margin-top: 20px;
`;

const ThemeLabel = styled.p`
  font-family: "Quicksand", sans-serif;
  font-size: 2.5vh;
  color: ${(props) =>
    props.isDarkMode ? "var(--font-dark)" : "var(--font-light)"};
  margin: 0;
  display: flex;
  align-items: center;
  height: 34px;
`;


const SolidButtonGold = styled(SolidButton)`
  &.primary {
    background: #f7c054;
    color: white;
    box-shadow: 0 4px 0 #d9a43d;
    width: 150px !important;
    height: 150px !important;

    &:hover {
      background: #ffd066;
    }

    &:active {
      box-shadow: 0 0 0 #d9a43d;
    }
  }
`;

const DonationSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FeedbackButton = styled(SolidButton)`
  &.primary {
    background: #8747d4;
    color: white;
    box-shadow: 0 4px 0 #6535a0;
    width: 150px !important;
    height: 150px !important;

    &:hover {
      background: #9859e0;
    }

    &:active {
      box-shadow: 0 0 0 #6535a0;
    }
  }
`;

// Split tile that occupies one button space but offers two actions (top/bottom)
const SplitTile = styled.button`
  &.primary {
    background: #8747d4;
    color: white;
    box-shadow: 0 4px 0 #6535a0;
    width: 150px !important;
    height: 150px !important;
    border: none;
    border-radius: 12px;
    overflow: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
  }
`;

const SplitHalf = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  user-select: none;
  &:first-child {
    background: rgba(255,255,255,0.06);
    border-bottom: 1px solid rgba(255,255,255,0.2);
  }
  &:last-child {
    background: rgba(255,255,255,0.04);
  }
  &:hover {
    background: rgba(255,255,255,0.12);
  }
`;

const DeleteAccountButton = styled(SolidButton)`
  &.danger {
    background: #dc3545;
    color: white;
    box-shadow: 0 4px 0 #c82333;
    width: 150px !important;
    height: 150px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
      background: #c82333;
    }

    &:active {
      box-shadow: 0 0 0 #c82333;
    }

    svg {
      font-size: 24px;
    }
  }
`;

const DangerZone = styled.div`
  background-color: ${(props) =>
    props.isDarkMode ? "#3c2c2c" : "#fff5f5"};
  border: 2px solid #dc3545;
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
`;

const DangerTitle = styled.h3`
  color: #dc3545;
  font-family: "Quicksand", sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DangerDescription = styled.p`
  color: ${(props) =>
    props.isDarkMode ? "var(--font-dark)" : "var(--font-light)"};
  font-family: "Quicksand", sans-serif;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 15px;
`;

const DangerButton = styled.button`
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-family: "Quicksand", sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #c82333;
    transform: translateY(-1px);
  }
`;

const ChangeNameButton = styled.button`
  background-color: transparent;
  color: #8747d4;
  border: 1px solid #8747d4;
  border-radius: 8px;
  padding: 8px 14px;
  font-family: "Quicksand", sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: #8747d4;
    color: white;
  }
`;

function Profile() {
  const userEmail = localStorage.getItem("userEmail");
  let { userRole, isDarkMode, toggleMode } = useAmazonContext();
  const history = useHistory();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showNameModal, setShowNameModal] = useState(false);
  const [givenName, setGivenName] = useState(
    () => localStorage.getItem("userGivenName") || ""
  );
  const [familyName, setFamilyName] = useState(
    () => localStorage.getItem("userFamilyName") || ""
  );
  const [originalGivenName, setOriginalGivenName] = useState("");
  const [originalFamilyName, setOriginalFamilyName] = useState("");

  const fullName = [givenName, familyName].filter(Boolean).join(" ").trim();
  const originalFullName = [originalGivenName, originalFamilyName]
    .filter(Boolean)
    .join(" ")
    .trim();

  const handleNameSaved = (newGiven, newFamily) => {
    localStorage.setItem("userGivenName", newGiven);
    localStorage.setItem("userFamilyName", newFamily);
    setGivenName(newGiven);
    setFamilyName(newFamily);
  };

  useEffect(() => {
    if (!userEmail) return;

    const fetchAndResolveDisplayName = async () => {
      try {
        const response = await api.get("/fetchUserRole", {
          params: { userEmail },
        });

        const user = response?.data || {};
        const resolvedGivenName =
          user.displayGivenName || user.givenName || "Anonymous";
        const resolvedFamilyName =
          user.displayFamilyName || user.familyName || "User";
        const sourceGivenName = user.givenName || "";
        const sourceFamilyName = user.familyName || "";

        localStorage.setItem("userGivenName", resolvedGivenName);
        localStorage.setItem("userFamilyName", resolvedFamilyName);
        setGivenName(resolvedGivenName);
        setFamilyName(resolvedFamilyName);
        setOriginalGivenName(sourceGivenName);
        setOriginalFamilyName(sourceFamilyName);
      } catch (error) {
        console.error("Error resolving profile display name:", error);
      }
    };

    fetchAndResolveDisplayName();
  }, [userEmail]);

  const handleLessonBuilder = (e) => {
    e.preventDefault();
    setTimeout(() => {
      history.push("/course-import");
    }, 150);
  };

  const handleLessonEditor = (e) => {
    e.preventDefault();
    setTimeout(() => {
      history.push("/course-editor");
    }, 150);
  };

  const handleDashboard = (e) => {
    e.preventDefault();
    setTimeout(() => {
      history.push("/dashboard");
    }, 150);
  };

  const handleAnnouncementAdmin = (e) => {
    e.preventDefault();
    setTimeout(() => {
      history.push("/announcement-admin");
    }, 150);
  };

  const handleFeedbackClick = () => {
    history.push("/feedback-forum");
  };

  const handleStreakFreeze = (e) => {
    e.preventDefault();
    setTimeout(() => {
      history.push("/streak-freeze");
    }, 150);
  };

  const handleKnowledgeChallenge = (e) => {
    e.preventDefault();
    setTimeout(() => {
      history.push("/knowledge-challenge-admin");
    }, 150);
  };

  const handleDeleteAccountClick = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  return (
    <>
      <Header className="sideNavChapterHeader">
        <p>My Profile</p>
      </Header>
      <Container>
        <ProfileInfo>
          <NameCard isDarkMode={isDarkMode}>
            <NameRow>
              <FaUser style={{ color: "#8747d4", marginTop: 2 }} />
              <NameText>
                <NameLabel isDarkMode={isDarkMode}>Preferred Name</NameLabel>
                <NameValue isDarkMode={isDarkMode}>
                  {fullName || "Anonymous User"}
                </NameValue>
              </NameText>
            </NameRow>
            <NameRow noMargin>
              <FaUser style={{ color: "#8747d4", marginTop: 2 }} />
              <NameText>
                <NameLabel isDarkMode={isDarkMode}>Original Name</NameLabel>
                <NameValue isDarkMode={isDarkMode}>
                  {originalFullName || fullName || "Anonymous User"}
                </NameValue>
              </NameText>
            </NameRow>
          </NameCard>
          <ChangeNameButton type="button" onClick={() => setShowNameModal(true)}>
            <FaPen /> Change name
          </ChangeNameButton>
          <InfoItem isDarkMode={isDarkMode} style={{ marginTop: 15 }}>
            <FaEnvelope /> {userEmail}
          </InfoItem>
          {userRole === "admin" && (
            <InfoItem isDarkMode={isDarkMode}>
              <FaCrown /> Admin privileges
            </InfoItem>
          )}
        </ProfileInfo>

        <ButtonContainer>
          {userRole === "admin" && (
            <>
              <SplitTile className="primary" type="button">
                <SplitHalf onClick={handleLessonBuilder}>
                  COURSE IMPORT
                </SplitHalf>
                <SplitHalf onClick={handleLessonEditor}>
                  COURSE EDITOR
                </SplitHalf>
              </SplitTile>
              <SolidButton className="primary" onClick={handleDashboard}>
                DASHBOARD
              </SolidButton>
              <SolidButton className="primary" onClick={handleAnnouncementAdmin}>
                SALAAM ADMIN
              </SolidButton>
              <SolidButton className="primary" onClick={handleStreakFreeze}>
                STREAK FREEZE
              </SolidButton>
              <SolidButton className="primary" onClick={handleKnowledgeChallenge}>
                KNOWLEDGE CHALLENGES
              </SolidButton>
            </>
          )}
          <SolidButtonGold
            className="primary"
            as="a"
            href="https://www.paypal.com/donate/?hosted_button_id=82TNM9C7875YC"
            target="_blank"
            rel="noopener noreferrer"
          >
            INVEST IN OUR SCHOOL
          </SolidButtonGold>
          <FeedbackButton className="primary" onClick={handleFeedbackClick}>
            REQUEST A COURSE / FEATURE
          </FeedbackButton>
        </ButtonContainer>

        <ThemeToggleContainer>
          <ThemeLabel isDarkMode={isDarkMode}>Dark/Light Mode</ThemeLabel>
          <ToggleSwitch>
            <input type="checkbox" checked={isDarkMode} onChange={toggleMode} />
            <span className="slider"></span>
          </ToggleSwitch>
        </ThemeToggleContainer>

        {/* Logout and Delete Account Section */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '30px', alignItems: 'center' }}>
          <UniversalLogout inline={true} />
          <DangerButton onClick={handleDeleteAccountClick}>
            Delete My Account
          </DangerButton>
        </div>

        {/* Conditional Danger Zone - only show when delete button is pressed */}
        {showDeleteModal && (
          <DangerZone isDarkMode={isDarkMode}>
            <DangerTitle>
              <FaTrash />
              Danger Zone
            </DangerTitle>
            <DangerDescription isDarkMode={isDarkMode}>
              Once you delete your account, there is no going back. This action cannot be undone.
              All your progress, achievements, and data will be permanently removed.
            </DangerDescription>
          </DangerZone>
        )}
      </Container>
      <BottomNavBar />
      
      <AccountDeletion 
        isOpen={showDeleteModal} 
        onClose={handleCloseDeleteModal} 
      />

      <DisplayNameModal
        isOpen={showNameModal}
        onClose={() => setShowNameModal(false)}
        currentGivenName={givenName}
        currentFamilyName={familyName}
        onSaved={handleNameSaved}
      />
    <div style={{ height: '100px' }} />
    </>
  );
}

export default Profile;
